import { endOfDay, endOfWeek, startOfDay, startOfWeek } from 'date-fns';

import { convertTimeZones } from 'utils/date';

/**
 * Map startDateFrom to sendDateFrom for the API request
 * @returns {{sendDateFrom: string, sendDateTo: string}}
 */
const getDates = (actionStart, actionEnd, timeZoneOffset = Intl.DateTimeFormat().resolvedOptions().timeZone) => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  return ({
    sendDateFrom: convertTimeZones(actionStart(new Date()), timeZoneOffset, timeZone).toISOString(),
    sendDateTo: convertTimeZones(actionEnd(new Date()), timeZoneOffset, timeZone).toISOString(),
  });
};

export const getDayDates = (timeZoneOffset) => getDates(startOfDay, endOfDay, timeZoneOffset);
export const getWeekDates = (timeZoneOffset) => getDates(startOfWeek, endOfWeek, timeZoneOffset);
